import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { IShopUser } from 'types/income';
import { TableDataResponse } from 'types/general';
import { getSorting } from 'utils/general';
import { ShopUsersFilters } from './shop-users.types';

const getFilters = (filters: Partial<ShopUsersFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  ...getSorting(filters.sort),
  search: filters.search || undefined,
  filter: {
    employeeIds: filters.employeeIds,
    name: filters.name || undefined,
    email: filters.email || undefined,
    phoneNumber: filters.phoneNumber || undefined,
  },
});

interface GetShopUsers {
  filters: Partial<ShopUsersFilters>;
}

interface GetShopUser {
  shopUserId: string;
}

export const loaders = {
  getShopUsers: ({ filters }: GetShopUsers) => {
    return api<TableDataResponse<IShopUser>>({
      url: Endpoints.clientAdmin.shopUsers.root,
      context: 'melp',
      params: getFilters(filters),
    });
  },
  getShopUser: ({ shopUserId }: GetShopUser) => {
    return api<IShopUser>({
      url: Endpoints.clientAdmin.shopUsers.byId.replace(
        ':shopUserId',
        shopUserId,
      ),
      context: 'melp',
    });
  },
};
